export default __webpack_public_path__ + "static/media/background_register.df2b924a.jpg";